import { connect } from 'react-redux';

import { getComplaintsList } from './complaintsActions';
import { sendExportExcelRequest } from '../TransferringRequests/transferringRequestsActions';
import Complaints from './Complaints';

const mapStateToProps = state => ({
  complaintsList: state.complaints.complaintsList,
  isLoading: state.complaints.isLoading,
  reportLoading: state.transferringRequests.reportLoading,
});

const mapDispatchToProps = dispatch => ({
  getComplaintsList: params => dispatch(getComplaintsList(params)),
  sendExportExcelRequest: (params, type) => dispatch(sendExportExcelRequest(params, type)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Complaints);
